<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <ng-container *ngIf="loading; else content;">
                    <h1 class="h3 mb-0 text-gray-800">Duplicate Users</h1>

                    <div class="loading text-center">
                        <br />
                        <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                        <br />
                        <p>Loading, please wait...</p>
                    </div>
                </ng-container>

                <ng-template #content>
                    <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                        <h1 class="h3 mb-0 text-gray-800">Duplicate Users</h1>
                        <a (click)="downloadAsCSV()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                            <i class="fas fa-file-export"> <span class="button-text"> Download as .CSV</span></i>
                        </a>
                    </div>

                    <div class="card shadow">
                        <div class="container-fluid">
                            <div style="width: 100%; max-height: 400px; height:400px;">
                                <ag-grid-angular #agGrid
                                                 style="width: 100%; height: 100%;"
                                                 class="ag-theme-balham"
                                                 [enableFilter]="true"
                                                 [gridOptions]="gridOptions"
                                                 [rowData]="data"
                                                 [columnDefs]="dataHeaders"
                                                 [enableSorting]="true"
                                                 [floatingFilter]="true"
                                                 [enableColResize]="true"
                                                 (gridReady)="onGridReady($event)"
                                                 [pagination]="true"
                                                 [paginationPageSize]="25"
                                                 [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                 [suppressRowClickSelection]="true">
                                </ag-grid-angular>
                            </div>

                        </div>
                    </div>

                    </ng-template>
                </div>
        </div>
    </div>
</div>
